// TODO: Check how to fetch this from api without token session
const UK = { id: 1, name: 'United Kingdom', code: 'UK' };
const NZ = { id: 2, name: 'New Zealand', code: 'NZ' };
const AUS = { id: 4, name: 'Australia', code: 'AUS' };
const ANZ_CODE_REGIONS = [NZ.code, AUS.code];

export { UK, AUS, NZ, ANZ_CODE_REGIONS };
